import React, { useEffect } from "react";

import AppRoutes from "./routes/AppRoutes";
import { CssBaseline } from "@mui/material";

import { useLocation } from "react-router-dom";


function App() {

  const location = useLocation();

  useEffect(() => {
    // Só em produção (não roda em localhost)
    if (window.location.hostname === "localhost") return;

    // Garante que o Pixel carregou
    if (!window.fbq) return;

    const path = location.pathname;

    if (path === "/" || path === "/cadastro" || path === "/assinar" || path === "/planejamento") {
      window.fbq("track", "PageView");
    }
  }, [location.pathname]);

  return (
    <>
      <CssBaseline />
      <AppRoutes />
    </>
  );
}

export default App;